module.exports = __webpack_public_path__ + "static/monkey_1920-282ce54f4451b284fe7594bdd7d21bda.mp4";